export const IMAGE_PLACEHOLDER_COMPONENTS_TYPES = [
	'WPhoto',
	'ImageX',
	'ImageButton',
	'MediaPlayer',
	'StripColumnsContainer',
	'Column',
	'ClassicSection',
	'SlideShowSlide',
	'PageBackground',
	'HoverBox',
	'Section',
	'HeaderSection',
	'FooterSection',
	'LinkBar',
	'TextMask',
	'MatrixGallery',
	'PaginatedGridGallery',
	'SliderGallery',
	'SlideShowGallery',
]
